import { Breadcrumb, Col, Modal, Row, Tag } from "antd";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Eye, Globe } from "lucide-react";
import { AppContentLayout } from "../../../layout/applayout";
import { AUTH_TOKEN, DOMAIN_ID, JsonCellRenderer, ORG_ID } from "../../../utils/helpers";
import { didAxios } from "../../../service/didService";
import DataGridTable from "../../../components/ui/DataGridTable";

const AgentLogs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const hostName = queryParams.get("hostName");
  const [isLoading, setIsLoading] = useState(false);
  const [agentLogs, setAgentLogs] = useState([]);
  const [selectedJSONData, setSelectedJSONData] = useState();
  const [isViewJson, setIsViewJson] = useState(false);
  //pagination
  const [paginationParams, setPaginationParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);
  const PAGESIZE = 10;
  const [currentPageModel, setCurrentPageModel] = useState({
    pageSize: PAGESIZE,
    page: 0,
  });
  // UI configuration
  const columns = [
    {
      field: "log_message",
      headerName: "JSON",
      flex: 1,
      height: 600,
      renderCell: (row, record) => (
        <>
          <Tag
            className="space-x-1 flex items-center cursor-pointer justify-center"
            onClick={() => {
              setSelectedJSONData(row.value);
              setIsViewJson(true);
            }}
            color={"blue"}
          >
            <Eye className="!size-3.5" />
            <span>View</span>
          </Tag>
        </>
      ),
    },
    {
      field: "host_name",
      headerName: "Host Name",
      flex: 1,
    },
  ];

  useEffect(() => {
    fetchAgentLogs();
  }, []);

  const fetchAgentLogs = async () => {
    try {
      setIsLoading(true);
      let payload = {
        orgId: ORG_ID(),
        tenantId: DOMAIN_ID(),
        hostName: hostName,
      };
      const res = await didAxios.post(`/log/endpoint/logdisplay`, payload, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      });
      // Check if the data is null or empty
      if (!res?.data?.data || res.data.data.length === 0) {
        setAgentLogs([]);
        setIsLoading(false);
        return;
      }

      // Process data
      let tempData = res.data.data.map((item) => {
        return {
          ...item,
          id: item.id,
          org_id: item.org_id,
          tenant_id: item.tenant_id,
          log_message: {
            log_message: item.log_message,
            public_ip: item.public_ip,
            created_at: item.created_at,
          },
          host_name: item.host_name,
        };
      });
      setAgentLogs(tempData);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("fetchAgentLogs failed:", error?.response?.status, error?.message);
    }
  };

  return (
    <>
      <AppContentLayout
        title={
          <div className="bg-white border-b px-4 py-4">
            <Breadcrumb
              items={[
                {
                  title: (
                    <div onClick={() => navigate(-1)} className="flex items-center cursor-pointer space-x-1 font-semibold">
                      <Globe className="!size-4" />
                      <span>Endpoints</span>
                    </div>
                  ),
                },
                {
                  title: "Agent logs",
                },
              ]}
            />
          </div>
        }
        cardChildren={
          <>
            <div className="bg-gray-50 p-4 rounded-lg mb-6 gap-6">
              <h2 className="text-lg font-semibold">
                Endpoint Agent Logs -<span style={{ color: "blue" }}>{hostName}</span>
              </h2>
            </div>
            <DataGridTable
              loading={isLoading}
              setLoading={setIsLoading}
              tableStruture={columns}
              data={agentLogs}
              totalCount={totalCount}
              pagination={paginationParams}
              handleChangePagination={(page, pageSize) => {
                setPaginationParams({ current: page, pageSize });
              }}
            />
          </>
        }
      />
      {isViewJson && (
        <Modal open={isViewJson} title={<span>Log Messages</span>} onCancel={() => setIsViewJson(false)} footer={null} width={600}>
          <Row>
            <Col span={24}>
              <JsonCellRenderer value={selectedJSONData || {}} />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};

export default AgentLogs;
